import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectShopifyShopName } from '../../../../redux/fashion-store/selectors';

import { PRICING_PAGE_LINK } from 'utils/configs';

import handleError from 'services/handleError';
import Divider from 'components/smallStatic/Divider';
import { ExitBtn } from 'components/common/Buttons/Buttons';
import icon from 'media/images/svgSprite.svg';

import {
  LinkListWrap,
  MenuList,
  LinkWrap,
  NavItem,
  ATag,
  MenuTitle,
  ToolsIcon,
} from 'components/user/UserMenu/LinkList/LinkList.styled';

const LinkList = ({ onCloseMenu }) => {
  const navigate = useNavigate();
  const shopifyShopName = useSelector(selectShopifyShopName);

  function onLogout() {
    handleError(401);
    navigate('signin');
    onCloseMenu();
  }

  return (
    <LinkListWrap>
      <MenuList>
        <LinkWrap key={'link-list-account'}>
          <NavItem to="user-cabinet" onClick={onCloseMenu}>
            <ToolsIcon>
              <use href={`${icon}#icon-settings`}></use>
            </ToolsIcon>
            <MenuTitle>account</MenuTitle>
          </NavItem>
        </LinkWrap>
        <LinkWrap key={'link-list-pricing'}>
          {shopifyShopName ? (
            <ATag
              href={PRICING_PAGE_LINK}
              rel="noreferrer noopener"
              target={shopifyShopName ? '_blank' : '_self'}
              onClick={onCloseMenu}
            >
              <ToolsIcon>
                <use href={`${icon}#icon-price`}></use>
              </ToolsIcon>
              <MenuTitle>pricing</MenuTitle>
            </ATag>
          ) : (
            <NavItem to="pricing" onClick={onCloseMenu}>
              <ToolsIcon>
                <use href={`${icon}#icon-price`}></use>
              </ToolsIcon>
              <MenuTitle>pricing</MenuTitle>
            </NavItem>
          )}
        </LinkWrap>
      </MenuList>

      <Divider />

      <ExitBtn handleLogout={onLogout}>
        <ToolsIcon>
          <use href={`${icon}#icon-logout`}></use>
        </ToolsIcon>
        logout
      </ExitBtn>
    </LinkListWrap>
  );
};

export default LinkList;
